import React, { useState } from 'react';
import './../styles/index.css';

import { Row, Button, Col } from 'react-bootstrap';

import useSound from 'use-sound';

import ConfirmBox from './confirmBox'


import { z010ma0a } from './sound.js';
import { z010ma0b } from './sound.js';
import { z010ma0c } from './sound.js';
import { z015ma0c } from './sound.js';
import { z010mi0a } from './sound.js';
import { z010mi0b } from './sound.js';
import { z010mi0c } from './sound.js';
import { z015mi0c } from './sound.js';
import { z020mi0a } from './sound.js';
import { z020mi0b } from './sound.js';
import { z020di0a } from './sound.js';
import { z020di0b } from './sound.js';
import { z030mi0a } from './sound.js';
import { z030mi0b } from './sound.js';
import { z630ma0a } from './sound.js';
import { z630ma0b } from './sound.js';
import { z040ma0a } from './sound.js';
import { z040ma0b } from './sound.js';
import { z040ma0c } from './sound.js';
import { z040mi0a } from './sound.js';
import { z040mi0b } from './sound.js';
import { z040mi0c } from './sound.js';
import { z050ma0a } from './sound.js';
import { z050ma0b } from './sound.js';
import { z050ma0c } from './sound.js';
import { z050ma7d } from './sound.js';
import { z050mi0a } from './sound.js';
import { z060mi0b } from './sound.js';
import { z060mi0a } from './sound.js';
import { z660ma0a } from './sound.js';
import { z660ma0b } from './sound.js';
import { z075di7a } from './sound.js';
import { z070di0b } from './sound.js';
import { z670ma0a } from './sound.js';

import { RiCloseCircleFill, RiCheckboxCircleFill } from 'react-icons/ri';


export default function GridButton(props) {

    let [combi, setCombi] = useState([]);
    let [soundCombi, setSoundCombi] = useState([]);
    let [previewCombi, setPreviewCombi] = useState([]);
    let [activePos, setActivePos] = useState("a0,a1,a2,a3,a4,a5,a6,a7,a8,a9,a10,a11,a12,a13,a14,a15,a16,a17,a18,a19,a20,a21,a22,a23,a24,");
    const { selectCombi } = props; //to pass combi back to the parent playsound.js
    let myVolume = 1;
    if (props.volume === "off") myVolume = 0;

    const [playz010ma0a] = useSound(z010ma0a,
        { volume: myVolume }
    );
    const [playz010ma0b] = useSound(z010ma0b,
        { volume: myVolume }
    );
    const [playz010ma0c] = useSound(z010ma0c,
        { volume: myVolume }
    );
    const [playz015ma0c] = useSound(z015ma0c,
        { volume: myVolume }
    );
    const [playz010mi0a] = useSound(z010mi0a,
        { volume: myVolume }
    );
    const [playz010mi0b] = useSound(z010mi0b,
        { volume: myVolume }
    );
    const [playz010mi0c] = useSound(z010mi0c,
        { volume: myVolume }
    );
    const [playz015mi0c] = useSound(z015mi0c,
        { volume: myVolume }
    );
    const [playz020mi0a] = useSound(z020mi0a,
        { volume: myVolume }
    );
    const [playz020mi0b] = useSound(z020mi0b,
        { volume: myVolume }
    );
    const [playz020di0a] = useSound(z020di0a,
        { volume: myVolume }
    );
    const [playz020di0b] = useSound(z020di0b,
        { volume: myVolume }
    );
    const [playz030mi0a] = useSound(z030mi0a,
        { volume: myVolume }
    );
    const [playz030mi0b] = useSound(z030mi0b,
        { volume: myVolume }
    );
    const [playz630ma0a] = useSound(z630ma0a,
        { volume: myVolume }
    );
    const [playz630ma0b] = useSound(z630ma0b,
        { volume: myVolume }
    );
    const [playz040ma0a] = useSound(z040ma0a,
        { volume: myVolume }
    );
    const [playz040ma0b] = useSound(z040ma0b,
        { volume: myVolume }
    );
    const [playz040ma0c] = useSound(z040ma0c,
        { volume: myVolume }
    );
    const [playz040mi0a] = useSound(z040mi0a,
        { volume: myVolume }
    );
    const [playz040mi0b] = useSound(z040mi0b,
        { volume: myVolume }
    );
    const [playz040mi0c] = useSound(z040mi0c,
        { volume: myVolume }
    );
    const [playz050ma0a] = useSound(z050ma0a,
        { volume: myVolume }
    );
    const [playz050ma0b] = useSound(z050ma0b,
        { volume: myVolume }
    );
    const [playz050ma0c] = useSound(z050ma0c,
        { volume: myVolume }
    );
    const [playz050ma7d] = useSound(z050ma7d,
        { volume: myVolume }
    );
    const [playz050mi0a] = useSound(z050mi0a,
        { volume: myVolume }
    );
    const [playz060mi0b] = useSound(z060mi0b,
        { volume: myVolume }
    );
    const [playz060mi0a] = useSound(z060mi0a,
        { volume: myVolume }
    );
    const [playz660ma0a] = useSound(z660ma0a,
        { volume: myVolume }
    );
    const [playz660ma0b] = useSound(z660ma0b,
        { volume: myVolume }
    );
    const [playz075di7a] = useSound(z075di7a,
        { volume: myVolume }
    );
    const [playz070di0b] = useSound(z070di0b,
        { volume: myVolume }
    );
    const [playz670ma0a] = useSound(z670ma0a,
        { volume: myVolume }
    );

    //type defines whether user clicks on one notation only or is trying to place a series of notations. type = single/multiple
    const playSound = (soundCode, notationCode, clickedPos, type) => {

        let adjacentPos = "";


        switch (soundCode) {
            case "z010ma0a":
                playz010ma0a();
                break;
            case "z010ma0b":
                playz010ma0b();
                break;
            case "z010ma0c":
                playz010ma0c();
                break;
            case "z015ma0c":
                playz015ma0c();
                break;
            case "z010mi0a":
                playz010mi0a();
                break;
            case "z010mi0b":
                playz010mi0b();
                break;
            case "z010mi0c":
                playz010mi0c();
                break;
            case "z015mi0c":
                playz015mi0c();
                break;
            case "z020mi0a":
                playz020mi0a();
                break;
            case "z020mi0b":
                playz020mi0b();
                break;
            case "z020di0a":
                playz020di0a();
                break;
            case "z020di0b":
                playz020di0b();
                break;
            case "z030mi0a":
                playz030mi0a();
                break;
            case "z030mi0b":
                playz030mi0b();
                break;
            case "z630ma0a":
                playz630ma0a();
                break;
            case "z630ma0b":
                playz630ma0b();
                break;
            case "z040ma0a":
                playz040ma0a();
                break;
            case "z040ma0b":
                playz040ma0b();
                break;
            case "z040ma0c":
                playz040ma0c();
                break;
            case "z040mi0a":
                playz040mi0a();
                break;
            case "z040mi0b":
                playz040mi0b();
                break;
            case "z040mi0c":
                playz040mi0c();
                break;
            case "z050ma0a":
                playz050ma0a();
                break;
            case "z050ma0b":
                playz050ma0b();
                break;
            case "z050ma0c":
                playz050ma0c();
                break;
            case "z050ma7d":
                playz050ma7d();
                break;
            case "z050mi0a":
                playz050mi0a();
                break;
            case "z060mi0b":
                playz060mi0b();
                break;
            case "z060mi0a":
                playz060mi0a();
                break;
            case "z660ma0a":
                playz660ma0a();
                break;
            case "z660ma0b":
                playz660ma0b();
                break;
            case "z075di7a":
                playz075di7a();
                break;
            case "z070di0b":
                playz070di0b();
                break;
            case "z670ma0a":
                playz670ma0a();
                break;
            default:
                console.log("default")
        }



        //do the following only when user clicks on single notation
        if (type === "single") {
            let mycombi = [...combi];
            let mySoundCombi = [...soundCombi];
            if (combi.length < 4) {
                mycombi.push(notationCode);
                mySoundCombi.push(soundCode);

                if (mycombi.length > 0 && mycombi.length < 4) {
                    //find a list of adjacent positions based on code
                    //prefix a "a" and postfix a "," to make each position number unique, to be used for comparison in enabling and disabling the buttons
                    for (var i = 0; i < props.position.length; i++) {
                        if (clickedPos === props.position[i].position)
                            adjacentPos += "a" + props.position[i].adjacentposition + ",";
                    }
                }

                setCombi(mycombi);
                setSoundCombi(mySoundCombi);
                setPreviewCombi(getDisplayCombi(mycombi))
            }
            setActivePos(adjacentPos)

        }
    }



    //submitting only 1 combination of notations only
    const onSubmit = () => {

        let score = 0;
        let myresults = [];
        let answer = props.answer;
        let adjacentPos = "";
        let found = false;



        //check if combi from user is one of the correct answers
        for (var i = 0; i < answer.length; i++) {
            if (combi.length === 3 && answer[i].total === 3 && combi[0] === answer[i].p1 && combi[1] === answer[i].p2 && combi[2] === answer[i].p3) {
                score = 2;
                found = true;
                break;
            }
            if (combi.length === 4 && answer[i].total === 4 && combi[0] === answer[i].p1 && combi[1] === answer[i].p2 && combi[2] === answer[i].p3 && combi[3] === answer[i].p4) {
                score = 4;
                found = true;
                break;
            }


            if (found === false) {
                score = -1;
            }

            found = false;
        }



        //save the combi
        myresults.push({ combi: combi, soundCombi: soundCombi, displayCombi: getDisplayCombi(combi), score: score })


        //pass submitted combination to the playsound.js 
        selectCombi(myresults, "submitCombi");




        //reset combi
        setCombi([]);
        setSoundCombi([]);

        //reset active positions
        for (var k = 0; k < 25; k++) {
            adjacentPos += "a" + k + ",";
        }
        setActivePos(adjacentPos)
    }

    // const reShuffleGrid = () => {

    //     //pass nothing for combination and reshuffle flag to the playsound.js
    //     selectCombi("", "reshuffle");
    // }

    const restart = () => {
        //pass nothing for combination and reshuffle flag to the playsound.js
        selectCombi("", "restart");
    }

    const newGame = () => {

        //pass nothing for combination and reshuffle flag to the playsound.js
        selectCombi("", "newgame");
    }

    const onReset = () => {

        let adjacentPos = "";
        //reset combi
        setCombi([]);
        setSoundCombi([]);
        setPreviewCombi([]);

        //reset active positions
        for (var i = 0; i < 25; i++) {
            adjacentPos += "a" + i + ",";
        }
        setActivePos(adjacentPos)
    }

    //getting the notation for display using codes from combi
    const getDisplayCombi = (combi) => {

        let output = [];
        for (var i = 0; i < combi.length; i++) {
            for (var n = 0; n < props.notation.length; n++) {
                if (combi[i] === props.notation[n].code)
                    output.push(props.notation[n]);
            }
        }

        return output;
    }

    //getting callback from confirmbox if user wants to restart or new game
    const onSelectConfirm = (status) => {
        if (status === "restart") {
            restart();
        }
        if (status === "newgame") {
            newGame();
        }
    }



    return (

        <div>
            <Row className="timer-gap">
                <Col xs={3} className="text-end ">
                    <Button className="resetButton" onClick={() => onReset()} >
                        < RiCloseCircleFill size={`${window.outerWidth > 576 ? '55' : '40'}`} />
                    </Button>
                </Col>
                <Col className="transparentBackground previewText">
                    {
                        previewCombi.map((item, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {index < 4 && props.chord === "American" && <><span className="supsub">{item.b_superscript !== null && <sup>{item.b_superscript}</sup>}</span>{item.main}<span className="supsub">
                                        {(item.superscript !== null && !item.superscript.includes("~")) && <sup>{item.superscript}</sup>}
                                        {(item.superscript !== null && item.superscript.includes("~")) && <sup><span className='specialFont'>{item.superscript.substring(0, 1).replace("~", "∅")}</span>{item.superscript.substring(1, 2)}</sup>}

                                        {item.subscript !== null && <sub>{item.subscript}</sub>} </span> &nbsp; </>}

                                    {index < 4 && props.chord === "British" && <><span className="supsub">{item.b_superscript !== null && <sup>{item.b_superscript}</sup>}</span>{item.main}<span className="supsub">
                                        {(item.british_superscript !== null && !item.british_superscript.includes("~")) && <sup>{item.british_superscript}</sup>}
                                        {(item.british_superscript !== null && item.british_superscript.includes("~")) && <sup><span className='specialFont'>{item.british_superscript.substring(0, 1).replace("~", "∅")}</span>{item.british_superscript.substring(1, 2)}</sup>}

                                        {item.british_subscript !== null && <sub>{item.british_subscript}</sub>} </span>{item.british_extra} </>}

                                   


                                    &nbsp;
                                </React.Fragment>
                            );
                        })
                    }

                </Col>

                <Col xs={3} className="text-start ">
                    {combi.length > 2 && <Button className="submitButton" onClick={() => onSubmit()} >< RiCheckboxCircleFill size={`${window.outerWidth > 576 ? '55' : '40'}`} /></Button>}
                    {combi.length < 3 && <Button className="submitButton" disabled >< RiCheckboxCircleFill size={`${window.outerWidth > 576 ? '55' : '40'}`} /></Button>}
                </Col>

            </Row>

            <Row>
                <Col>
                    {/* display a list of notation for comparing American and British notations */}
                    {
                        props.grid.map((item, index) => {


                            return (
                                <React.Fragment key={index}>
                                    {activePos.includes("a" + index + ",") === true && <Button className={`gridButton ${item.category}`} onClick={() => playSound(item.sound, item.code, index, "single")} key={index}>

                                        {props.chord === "American" && <><span className="supsub">{item.b_superscript !== null && <sup>{item.b_superscript}</sup>}</span>{item.main}<span className="supsub">

                                            {(item.superscript !== null && !item.superscript.includes("~")) && <sup>{item.superscript}</sup>}
                                            {(item.superscript !== null && item.superscript.includes("~")) && <sup><span className='specialFont'>{item.superscript.substring(0, 1).replace("~", "∅")}</span>{item.superscript.substring(1, 2)}</sup>}

                                            {item.subscript !== null && <sub>{item.subscript}</sub>}</span> </>}

                                        {props.chord === "British" && <><span className="supsub">{item.b_superscript !== null && <sup>{item.b_superscript}</sup>}</span>{item.main}<span className="supsub">

                                            {(item.british_superscript !== null && !item.british_superscript.includes("~")) && <sup>{item.british_superscript}</sup>}
                                            {(item.british_superscript !== null && item.british_superscript.includes("~")) && <sup><span className='specialFont'>{item.british_superscript.substring(0, 1).replace("~", "∅")}</span>{item.british_superscript.substring(1, 2)}</sup>}

                                            {item.british_subscript !== null && <sub>{item.british_subscript}</sub>} </span>{item.british_extra} </>}

                                    </Button>}
                                    {activePos.includes("a" + index + ",") === false && <Button className="gridButton" disabled key={index}>

                                        {props.chord === "American" && <><span className="supsub">{item.b_superscript !== null && <sup>{item.b_superscript}</sup>}</span>{item.main}<span className="supsub">

                                            {(item.superscript !== null && !item.superscript.includes("~")) && <sup>{item.superscript}</sup>}
                                            {(item.superscript !== null && item.superscript.includes("~")) && <sup><span className='specialFont'>{item.superscript.substring(0, 1).replace("~", "∅")}</span>{item.superscript.substring(1, 2)}</sup>}

                                            {item.subscript !== null && <sub>{item.subscript}</sub>}</span> </>}

                                        {props.chord === "British" && <><span className="supsub">{item.b_superscript !== null && <sup>{item.b_superscript}</sup>}</span>{item.main}<span className="supsub">

                                            {(item.british_superscript !== null && !item.british_superscript.includes("~")) && <sup>{item.british_superscript}</sup>}
                                            {(item.british_superscript !== null && item.british_superscript.includes("~")) && <sup><span className='specialFont'>{item.british_superscript.substring(0, 1).replace("~", "∅")}</span>{item.british_superscript.substring(1, 2)}</sup>}

                                            {item.british_subscript !== null && <sub>{item.british_subscript}</sub>} </span>{item.british_extra} </>}

                                    </Button>}
                                    {(index + 1) % 5 === 0 && <><br /></>}
                                </React.Fragment>
                            );
                        })
                    }

                </Col>
            </Row>


            <Row>
                <Col className="d-flex justify-content-center">
                    {/* <Button className="bottomButton" onClick={() => reShuffleGrid()}>Reshuffle</Button> */}

                    <ConfirmBox selectConfirm={onSelectConfirm} button="Restart" header="Restart Game with same settings?" content="Do you want to continue? All submitted results will be removed." option="restart" />
                    <ConfirmBox selectConfirm={onSelectConfirm} button="New Game" header="Restart Game with new settings?" content="Do you want to continue? All submitted results will be removed." option="newgame" />
                </Col>
            </Row>
        </div>
    )
}